import { render, staticRenderFns } from "./DetailIncomeStatement.vue?vue&type=template&id=28203820"
import script from "./DetailIncomeStatement.vue?vue&type=script&lang=js"
export * from "./DetailIncomeStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports